/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCrmProjectInput
 */
export interface UpdateCrmProjectInput {
    /**
     * 
     * @type {UpdateCrmProjectInputCrmStatusEnum}
     * @memberof UpdateCrmProjectInput
     */
    crmStatus?: UpdateCrmProjectInputCrmStatusEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCrmProjectInput
     */
    nextContactAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmProjectInput
     */
    primaryContactUserId?: string | null;
}


/**
 * @export
 */
export const UpdateCrmProjectInputCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type UpdateCrmProjectInputCrmStatusEnum = typeof UpdateCrmProjectInputCrmStatusEnum[keyof typeof UpdateCrmProjectInputCrmStatusEnum];


/**
 * Check if a given object implements the UpdateCrmProjectInput interface.
 */
export function instanceOfUpdateCrmProjectInput(value: object): value is UpdateCrmProjectInput {
    return true;
}

export function UpdateCrmProjectInputFromJSON(json: any): UpdateCrmProjectInput {
    return UpdateCrmProjectInputFromJSONTyped(json, false);
}

export function UpdateCrmProjectInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCrmProjectInput {
    if (json == null) {
        return json;
    }
    return {
        
        'crmStatus': json['crmStatus'] === undefined ? undefined : json['crmStatus'] === null ? null : json['crmStatus'],
        'nextContactAt': json['nextContactAt'] === undefined ? undefined : json['nextContactAt'] === null ? null : (new Date(json['nextContactAt'])),
        'primaryContactUserId': json['primaryContactUserId'] === undefined ? undefined : json['primaryContactUserId'] === null ? null : json['primaryContactUserId'],
    };
}

export function UpdateCrmProjectInputToJSON(json: any): UpdateCrmProjectInput {
    return UpdateCrmProjectInputToJSONTyped(json, false);
}

export function UpdateCrmProjectInputToJSONTyped(value?: UpdateCrmProjectInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crmStatus': value['crmStatus'],
        'nextContactAt': value['nextContactAt'] == null ? value['nextContactAt'] : value['nextContactAt'].toISOString(),
        'primaryContactUserId': value['primaryContactUserId'],
    };
}

